import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CuentaCorrienteDetraccionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CTA CTE DETRACCION' htmlFor='input-cuentaCorrienteDetraccion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='cuentaCorrienteDetraccion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-cuentaCorrienteDetraccion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaCorrienteDetraccionFormGroup)
